// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.website_container__cIyj2 {
  display: flex;
  justify-content: center;
  width: 100%;
}
.website_container_form__hckAE {
  width: 60%;
  box-sizing: border-box;
  border: solid var(--color-fash-primary-3);
  padding: 3rem;
  margin-top: 4rem;
  align-items: center;
  border-radius: 1rem;
}
@media only screen and (max-width: 50em) {
  .website_container_form__hckAE {
    width: 80%;
  }
}
@media only screen and (max-width: 37.5em) {
  .website_container_form__hckAE {
    width: 100%;
  }
}
.website_container_form__domain__ulJ7M {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
}
.website_container_form__input__hA6br {
  width: 50rem;
}
@media only screen and (max-width: 62.5em) {
  .website_container_form__input__hA6br {
    width: 40rem;
  }
}
@media only screen and (max-width: 50em) {
  .website_container_form__input__hA6br {
    width: 32rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .website_container_form__input__hA6br {
    width: 22rem;
  }
}

.website_upperBtn__SJMfh {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.website_checks__fwaND {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.website_checks_group__hxy7y {
  align-self: center;
}

.website_dropZone__SP9kU {
  display: flex;
  width: 38rem;
  justify-content: center;
  align-items: center;
  background-size: contain;
}

.website_sizesRow__suxfS {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  /* Add some space between rows */
}

.website_checks__fwaND {
  width: 38rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.website_price__cyCHr {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  padding-bottom: 1rem;
  gap: 2rem;
}

.website_error__SRfSP {
  color: var(--color-error);
}

.website_imageGrid__uwlbx {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
  border: 1px solid var(--color-grey);
  padding: 1rem;
  border-radius: 1rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
.website_imageGrid__uwlbx img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.website_imageGrid__item__CB-oU {
  background-color: var(--color-grey);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4rem;
}
.website_imageGrid__item__large__wH6SY {
  grid-row: span 2;
}
.website_imageGrid__item__half__gD\\+X3 {
  grid-row: span 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/website/website.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AADF;AAGE;EAGE,UAAA;EACA,sBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;AAKI;EAXF;IAYI,UAAA;EAFJ;AACF;AAII;EAfF;IAgBI,WAAA;EADJ;AACF;AAGI;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AADN;AAII;EACE,YAAA;AAFN;AAIM;EAHF;IAII,YAAA;EADN;AACF;AAGM;EAPF;IAQI,YAAA;EAAN;AACF;AAEM;EAXF;IAYI,YAAA;EACN;AACF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AADF;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,SAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAFF;AAME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJJ;AAOE;EACE,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AALJ;AAOI;EACE,gBAAA;AALN;AAQI;EACE,gBAAA;AANN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  &_form {\n    // display: flex;\n    // justify-content: space-between;\n    width: 60%;\n    box-sizing: border-box;\n    border: solid var(--color-fash-primary-3);\n    padding: 3rem;\n    margin-top: 4rem;\n    align-items: center;\n    border-radius: 1rem;\n\n    @media only screen and (max-width: $bp-800) {\n      width: 80%;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n      width: 100%;\n    }\n\n    &__domain {\n      display: flex;\n      align-items: flex-end;\n      gap: 1rem;\n    }\n\n    &__input {\n      width: 50rem;\n\n      @media only screen and (max-width: $bp-1000) {\n        width: 40rem;\n      }\n\n      @media only screen and (max-width: $bp-800) {\n        width: 32rem;\n      }\n\n      @media only screen and (max-width: $bp-600) {\n        width: 22rem;\n      }\n    }\n  }\n}\n\n.upperBtn {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.checks {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem 0 2rem 0;\n\n  &_group {\n    align-self: center;\n  }\n}\n\n.dropZone {\n  display: flex;\n  width: 38rem;\n  justify-content: center;\n  align-items: center;\n  background-size: contain;\n}\n\n.sizesRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  /* Add some space between rows */\n}\n\n.checks {\n  width: 38rem;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n\n.price {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  padding-bottom: 1rem;\n  gap: 2rem;\n}\n\n.error {\n  color: var(--color-error);\n}\n\n.imageGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  width: 100%;\n  border: 1px solid var(--color-grey);\n  padding: 1rem;\n  border-radius: 1rem;\n  margin-bottom: 2rem;\n  cursor: pointer;\n\n\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__item {\n    background-color: var(--color-grey);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 2.4rem;\n\n    &__large {\n      grid-row: span 2;\n    }\n\n    &__half {\n      grid-row: span 1;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `website_container__cIyj2`,
	"container_form": `website_container_form__hckAE`,
	"container_form__domain": `website_container_form__domain__ulJ7M`,
	"container_form__input": `website_container_form__input__hA6br`,
	"upperBtn": `website_upperBtn__SJMfh`,
	"checks": `website_checks__fwaND`,
	"checks_group": `website_checks_group__hxy7y`,
	"dropZone": `website_dropZone__SP9kU`,
	"sizesRow": `website_sizesRow__suxfS`,
	"price": `website_price__cyCHr`,
	"error": `website_error__SRfSP`,
	"imageGrid": `website_imageGrid__uwlbx`,
	"imageGrid__item": `website_imageGrid__item__CB-oU`,
	"imageGrid__item__large": `website_imageGrid__item__large__wH6SY`,
	"imageGrid__item__half": `website_imageGrid__item__half__gD+X3`
};
export default ___CSS_LOADER_EXPORT___;
